import { render, staticRenderFns } from "./ChangeLogEntry.vue?vue&type=template&id=55b7ce74"
import script from "./ChangeLogEntry.vue?vue&type=script&lang=js"
export * from "./ChangeLogEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports